<template>
    <div v-if="show">
   
    <v-card dense>
        <v-toolbar>
            PER BILLER
            <v-spacer/>
               <span style="width: 200px; margin-top: 24px;"> 
                     <v-menu
                        v-model="from_menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field 
                                label="From Date"
                                 :value="from_date"
                                 filled
                                 readonly
                                dense
                                outlined
                                append-icon="mdi-calendar"
                                v-on="on"
                            />
                        </template>
                        <v-date-picker v-model="from_date" no-title scrollable @input="from_menu=false" />
                    </v-menu>
               </span>
                <span style="width: 200px; margin-top: 24px;" class="ml-2"> 
                     <v-menu
                        v-model="to_menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field 
                                label="To Date"
                                 :value="to_date"
                                 readonly
                                 filled
                                dense
                                outlined
                                append-icon="mdi-calendar"
                                v-on="on"
                            />
                        </template>
                        <v-date-picker v-model="to_date" no-title scrollable @input="to_menu=false, getTransactions()" />
                    </v-menu>
               </span>
               <v-icon right color="primary" @click="dlToCsv()">mdi-download</v-icon>
        </v-toolbar>
        <v-card-text>
             <v-progress-linear
                v-if="loading"
                indeterminate
                color="teal"
                ></v-progress-linear>
            
            <table class="va-table def-font" id="over-table">
                <tr>
                            <th>Name </th>
                            <th>Category</th>
                            <th class="text-right">Biller Fee</th>
                            <th class="text-right"> Total Service  Fee</th>
                            <th class="text-right">Total Collection</th>
                </tr>
                 <tr v-for="(item,index) in items" :key="index" >
                    <td class="border_bot">{{item.biller_name}} </td>
                    <td class="border_bot">{{item.biller_category}} </td>
                    <td class="border_bot text-right">{{$money(item.biller_fee)}} </td>
                    <td class="border_bot text-right" >{{$money(item.service_fee)}} </td>
                    <td class="border_bot text-right">{{$money(item.total_amount)}} </td>
                </tr>
                <tr>
                     <th  class="text-right" colspan="4" style="background: #efefef;">TOTAL:</th>
                    <th class="text-right"  style="background: #efefef;">{{$money(TOTALGROSS)}}</th>
                </tr>
               
            </table>
        </v-card-text>     
    </v-card>
  </div>
</template>

<script>

export default {
  props: {
      show:{
          type: Boolean,
          default: false
      }
  },
  data: () => ({
        loading: false,
        from_menu: false,
        to_menu: false,
        from_date: '',
        to_date: '',
        items:[]
       
    }),
    computed:{
        TOTALGROSS() {
            var total = this.items.reduce((res,item)=>res += this.$IsNum(item.total_amount),0)
            return total
        },
    },
    watch: {
        show(v) {
            if(v) {
                this.from_date = this.$moment().format("YYYY-MM-DD")
                this.to_date = this.$moment().format("YYYY-MM-DD")
                this.getTransactions()
            }
        }
    },
    methods: {
        getTransactions(){
            this.loading = true
            this.items =[]
            var param = {
                type: "PerBiller",
                date_meta: {
                    from: this.from_date,
                    to: this.to_date
                }
                }
             this.$http.post("get_report",param).then(response => {
                 console.log(response.data.items)
                response.data.items !=null?this.items = response.data.items:this.items =[]
                this.loading = false
          }).catch(e => {
            console.log(e.data)
          })
        },
        dlToCsv(){
            this.DownloadToCsv("over-table", 'Per-draw-' + this.from_date + '-to-' + this.to_date)
        }
  }
}
</script>
